import { UseAPI } from './api';
import { Controllers } from '../constants/Controllers'

export async function GetActiveJobs() {
    try {

        let request = JSON.stringify({})

        const response = await UseAPI(Controllers.ControllerAdmin + 'GetActiveJobs', request, 2)

        return response

    } catch (error) {
        console.log(error)
    }
}


export async function GetJober(Id) {
    try {

        let request = JSON.stringify({})

        const response = await UseAPI(Controllers.ControllerAdmin + 'GetJober/' + Id, request, 2)

        return response

    } catch (error) {
        console.log(error)
    }
}

export async function GetJobInfo(Id) {
    try {

        let request = JSON.stringify({})

        const response = await UseAPI(Controllers.ControllerAdmin + 'GetJobInformation/' + Id, request, 2)

        return response

    } catch (error) {
        console.log(error)
    }
}



export async function SearchJober(query, type) {
    try {
        let request = JSON.stringify({})

        const response = await UseAPI(Controllers.ControllerAdmin + `SearchQuery?type=${type}&query=${query}`, request, 2)

        return response
    } catch (error) {
        console.log(error)
    }
}

export async function UpdateJoberInformation(IdCliente,CPF, Email, Telefone) {
    try {
        let request = JSON.stringify({ IdCliente:IdCliente,CPF, Email, Telefone })

        const response = await UseAPI(Controllers.ControllerAdmin + 'UpdateJoberInformation', request, 1)

        return response

    } catch (error) {
        console.log(error)
    }
}











